import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const StyledContainer = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 170px);
`
